import Logo from '../../assets/logo.jpg'; 

const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
}

export async function displayRazorpay(data) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const token = localStorage.getItem('token');
    const authHeader = `Bearer ${token}`;

    const result = await fetch("https://api.zupptravel.com/api/v1/payment/addWalletAmount", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        'Authorization': authHeader
      },
      body: JSON.stringify({
        ...data,
        amount: Math.ceil(data?.amount * 100),
    }),
    });
    const myjson = await result.json();
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }

    const options = {
      key: "rzp_test_nHt6AlQV9V1HCD",
      amount: myjson.amount,
      currency: "INR",
      name: "zupptravel.com",
      description: "Upload E-wallet Money",
      image: { Logo },
      order_id: myjson.razorpayOrderId,
      handler: async function (response) {

        const data = {
            razorpayPaymentId: response.razorpay_payment_id,
            razorpayOrderId: myjson.razorpayOrderId,
            razorpaySignature: response.razorpay_signature,
            amount: myjson.amount,
        }

        const result = await fetch(
          "https://api.zupptravel.com/api/v1/payment/verify/addWalletAmount",
          {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            },
            body: JSON.stringify(data),
          }
        );
        const myjson2 = await result.json();
        if(myjson2?.success){
            alert("Successfully Added Amount");
            window.location.reload();
        }
      },
      prefill: {
        name: myjson.name,
        email: myjson.email,
        contact: myjson.phone,
      },
      notes: {
        address: "Zupptravel Corporate Office",
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new (window).Razorpay(options);
    paymentObject.open();
}